import { formatDateRange, formatMoney, formatPhoneNumber, getGuestsWord } from '../../utils/utils';
import Buttons from '../Buttons/Buttons';
import style from './Confirm.module.css';

export default function Confirm({
    name, phone, email, com,
    client,
    startSlot,
    durationMinutes,
    selectedHallData,
    hall, people,
    priceList,
    kinoNight,
    etc,
    etcSmeta,
    submitLoading,
    submitDisable,
    changePage,
    submit
}) {
    const salePerc = client[0]?.loyaltySale || 0;
    let priceFullHall = priceList.reduce((total, price) => {
        return total + (price.rate * price.hours);
    }, 0);
    let sale = priceFullHall * salePerc / 100;
    const priceFullEtc = Object.entries(etcSmeta).reduce((total, [key, quantity]) => {
        const service = etc.find(item => item.ID === Number(key));
        if (service) {
            return total + (service.Price * quantity);
        }
        return total;
    }, 0);

    if (kinoNight !== 0) {
        priceFullHall = kinoNight;
        sale = 0;
    }

    return (
        <>
            <div className={style.block_container}>
                <div className={style.block}>
                    <div className={style.title}>{formatDateRange(new Date(startSlot), durationMinutes)}</div>
                    <div className={style.text}><a href={selectedHallData.Link} target="_blank">г.Москва, {selectedHallData.AddressFull}</a></div>
                    <div className={style.text}>Зал №{hall}, {getGuestsWord(people)}</div>
                </div>
                <div className={style.block}>
                    <div className={style.text}>{name}, {formatPhoneNumber(phone)}</div>
                    {email && <div className={style.text}>{email}</div>}
                    {com && <div className={style.text}>{com}</div>}
                </div>
            </div>
            <div className={style.smeta_container}>
                <div className={style.smeta_title}>Расчет стоимости</div>
                <div className={style.smeta_block}>
                    {kinoNight === 0 ? (
                        <>
                            {priceList.map((price) => (
                                <div key={`smeta-item-${price.rate}`} className={style.smeta_item}>
                                    <div className={style.smeta_item_name}>
                                        Аренда зала с {price.periods[0].start} до {price.periods[0].end}
                                    </div>
                                    <div className={style.smeta_item_price}>
                                        {formatMoney(price.rate)} ₽ / ч <span>x</span> {price.hours}
                                    </div>
                                </div>
                            ))}
                            {salePerc !== 0 && (
                                <div className={style.smeta_sale}>Персональная скидка — {salePerc}%</div>
                            )}
                            {Object.entries(etcSmeta).length !== 0 && (
                                <div className={`${style.smeta_separator} ${salePerc === 0 && style.noSale}`}></div>
                            )}
                        </>
                    ) : (
                        <div key={`smeta-item-kinoNight`} className={style.smeta_item}>
                            <div className={style.smeta_item_name}>
                                Тариф «Кино-ночь»
                            </div>
                            <div className={style.smeta_item_price}>
                                {formatMoney(kinoNight)} ₽ <span>x</span> 1
                            </div>
                        </div>
                    )}
                    {Object.entries(etcSmeta).map(([key, value]) => (
                        <div key={`smeta-item-${key}`}  className={style.smeta_item}>
                            <div className={style.smeta_item_name}>{etc.find(item => item.ID === Number(key)).Name}</div>
                            <div className={style.smeta_item_price}>{formatMoney(etc.find(item => item.ID === (Number(key))).Price)} ₽ <span>x</span> {value}</div>
                        </div>
                    ))}
                </div>
            </div>
            <div className={style.price_block}>
                <div className={style.price}>
                    Итого: {formatMoney((priceFullHall - sale) + priceFullEtc)} ₽
                    {sale !== 0 && <span>{formatMoney(priceFullHall + priceFullEtc)} ₽</span>}
                </div>
            </div>
            <Buttons
                button1={{ text: "Забронировать", onClick: submit, disable: submitDisable, loading: submitLoading }}
                button2={{ text: "Назад", onClick: () => changePage(6) }}
            />
        </>
    )
}
